import {
  GET_PAYMENT_METHOD_LIST,
  GET_PAYMENT_METHOD_LIST_SUCCESS,
  GET_PAYMENT_METHOD_LIST_FAILURE,
} from "./actionType";

// Action for Payment Method
// Get Payment Method List
export const getPaymentMethodList = () => ({
  type: GET_PAYMENT_METHOD_LIST,
});

export const getPaymentMethodListSuccess = (paymentMethodList) => ({
  type: GET_PAYMENT_METHOD_LIST_SUCCESS,
  payload: paymentMethodList,
});

export const getPaymentMethodListFailure = (error) => ({
  type: GET_PAYMENT_METHOD_LIST_FAILURE,
  payload: error,
});
